var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "my-store-nav-button icon-button",
      attrs: {
        id: "my-store-nav-button",
        "data-ui": "site-header-action-local",
      },
    },
    [
      _c("IconXLg", {
        staticClass: "gnav-icon my-store-nav-button--icon close-icon",
      }),
      _vm._v(" "),
      _c("IconLocationPinStroke", {
        staticClass: "gnav-icon my-store-nav-button--icon location-icon",
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "my-store-nav-button__text-content" },
        [
          _c(
            "cdr-text",
            { attrs: { tag: "span", "data-visible": "desktop" } },
            [
              _vm._v("\n      " + _vm._s(_vm.myReiText) + "\n      "),
              _vm.availability
                ? _c(
                    "span",
                    { class: _vm.availabilityClasses },
                    [
                      _vm.preferredStore.temporarilyClosed ||
                      _vm.availability.temporarilyClosed
                        ? [_vm._v("\n          Temporarily Closed\n        ")]
                        : _vm.availability.open && _vm.availability.closesAt
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.availability.closesAt
                                    .replace("today", "")
                                    .replace("until", "til")
                                ) +
                                "\n        "
                            ),
                          ]
                        : !_vm.availability.open && _vm.availability.opensAt
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.availability.opensAt) +
                                "\n        "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "cdr-text",
            { attrs: { tag: "span", "data-visible": "desktop" } },
            [_vm._v("\n      " + _vm._s(_vm.storeName) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }